//
// initialize Bootstrap tooltips
//

var toggleMortgageTypeDropdown = (function () {
    'use strict';

    // Methods
    $(document).ready(function () {
        $(function () {
            $('[data-toggle="tooltip"]').tooltip({ html: true });
        });
    });

})();